import type { BriefProgress } from '@ghostwright/api-client';

export default function ProgressDots({ progress }: { progress: BriefProgress }) {
  return (
    <div className="inline-flex items-center gap-3 text-[13px] tracking-[0.005em] text-muted-foreground">
      Cluster {progress.clusterIndex + 1} of {progress.clusterTotal}
      <span className="inline-flex gap-1" aria-hidden="true">
        {progress.dots.map((state, i) => (
          <span
            key={i}
            className={`w-1.5 h-1.5 rounded-full ${
              state === 'done' ? 'bg-muted-foreground' :
              state === 'active' ? 'bg-primary' :
              'bg-border'
            }`}
          />
        ))}
      </span>
    </div>
  );
}
